import { useState } from 'react';
import {
  Input,
  InputWrapper
} from 'src/components/pages/WeeklyCalenderSearch/SearchMember/styles';

interface Props {
  onChange: (query: string) => void;
  placeholder?: string;
  value?: string;
}

export const ClientReigstrtaionInput = ({
  onChange,
  placeholder,
  value
}: Props) => {
  const [query, setQuery] = useState<string>(value || '');
  const [focused, setFocused] = useState<boolean>();

  const handleChange = (value: string) => {
    onChange(value);
  };

  return (
    <InputWrapper focused={focused}>
      <Input
        type="search"
        value={query}
        onChange={e => {
          setQuery(e.target.value);
          handleChange(e.target.value);
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder || '회원의 성함을 입력해주세요'}
      />
    </InputWrapper>
  );
};
